var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsDateString, IsUUID } from 'class-validator';
/**
 * @deprecated Use `ExerciseProgramCalendarResponseDto` from `./exercise-program-for-calendar-response.dto` instead.
 */
export class ExerciseProgramCalendar {
}
/**
 * @deprecated Use `ExerciseProgramForCalendarResponseDto` from `./exercise-program-for-calendar-response.dto` instead.
 */
export class ExerciseProgramForCalendarFullSizeDto {
    id;
    createdAt;
    updatedAt;
    day;
    exerciseProgramId;
    /**
     * @deprecated
     */
    programId;
    userId;
    exerciseProgram;
    completedOrSkipped;
    started;
    hasDevices;
    duration;
    /**
     * @deprecated
     */
    durationStr;
    exerciseCount;
    index;
    happensToday;
    totalActivityPoints;
    aquiredActivityPoints;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], ExerciseProgramForCalendarFullSizeDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], ExerciseProgramForCalendarFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], ExerciseProgramForCalendarFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ExerciseProgramForCalendarFullSizeDto.prototype, "day", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ExerciseProgramForCalendarFullSizeDto.prototype, "exerciseProgramId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ExerciseProgramForCalendarFullSizeDto.prototype, "programId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ExerciseProgramForCalendarFullSizeDto.prototype, "userId", void 0);
__decorate([
    Exclude(),
    __metadata("design:type", Function)
], ExerciseProgramForCalendarFullSizeDto.prototype, "exerciseProgram", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramForCalendarFullSizeDto.prototype, "completedOrSkipped", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramForCalendarFullSizeDto.prototype, "started", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramForCalendarFullSizeDto.prototype, "hasDevices", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramForCalendarFullSizeDto.prototype, "duration", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ExerciseProgramForCalendarFullSizeDto.prototype, "durationStr", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramForCalendarFullSizeDto.prototype, "exerciseCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramForCalendarFullSizeDto.prototype, "index", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramForCalendarFullSizeDto.prototype, "happensToday", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramForCalendarFullSizeDto.prototype, "totalActivityPoints", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramForCalendarFullSizeDto.prototype, "aquiredActivityPoints", void 0);
//# sourceMappingURL=exercise-program-calendar.dto.js.map